/**
 * Field types
 */
export const FIELD_TYPES = {
  string: 'string',
  list: 'list',
  number: 'number',
  dateTime: 'datetime',
  file: 'file',
  boolean: 'boolean',
  form: 'form',
};

/**
 * Element types
 */
export const ELEMENT_TYPES = {
  row: 'row',
  column: 'column',
  text: 'text',
  field: 'field',
  link: 'link',
  button: 'button',
};

/**
 * Date time widget types
 */
export const DATETIME_FIELD_TYPES = {
  datetimepicker: 'datetimepicker',
  datepicker: 'datepicker',
};
/**
 * BooleanField widget types
 */
export const BOOLEAN_FIELD_WIDGETS = {
  toggle: 'toggle',
  checkbox: 'checkbox',
};

/**
 * StringField widget types
 */
export const STRING_FIELD_WIDGETS = {
  texline: 'texline',
  textarea: 'textarea',
};

/**
 * ListField widget types
 */
export const LIST_FIELD_WIDGETS = {
  select: 'select',
  radios: 'radios',
  checkboxes: 'checkboxes',
  autocomplete: 'autocomplete',
};

/**
 * custom errors inputs
 */
export const INPUT_CUSTOM_ERRORS = {
  RANGE_OVER: 'rangeover',
  RANGE_UNDER: 'rangeunder',
  CHOICES_TOO_MANY: 'choicesmany',
  CHOICES_TOO_FEW: 'choicesfew',
  MAX_SIZE: 'maxsize',
  FILE_TYPE: 'filetype',
  REQUIRED: 'required',
};

/**
 * errors string
 */
export const INPUT_ERRORS_MESSAGES = {
  REQUIRED: 'Campo obbligatorio.',
  RANGE_OVER: 'Valore inserito è più grande del massimo permesso.',
  RANGE_UNDER: 'Valore inserito è più piccolo del minimo permesso.',
  CHOICES_TOO_MANY: 'Troppe scelte selezionate.',
  CHOICES_TOO_FEW: 'Troppo poche scelte selezionate.',
  PATTERN_NO_MATCH: 'Formato campo errato. Verifica le regole richieste!',
  MAX_SIZE: 'Dimensioni del file maggiori di quelle permesse.',
  FILE_TYPE: 'Tipo file non permesso.',
};
